<template>
  <div v-if="authPages">
    <router-view/>
  </div>
  <div v-else id="app" class="container-fluid content" v-bind:class="getMainCssClasses()">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <Navbar v-show="showNav"/>
        </div>
      </div>
    </div>
    <div :class="topMargin" ></div>
    <router-view/>
    <div class="row">
      <div class="col-lg-12 before-footer">
        <!--x-->
      </div>
    </div>
    <Footer :showmenu="showNav"/>
    <div>
      <b-alert
          v-model="showCookieAlert"
          class="position-fixed fixed-bottom m-0 rounded-0 cookie-accept"
          variant="secondary"
          dismissible
      >{{ $t('app.byClickingOn') }}<router-link to="/cookie" @click.native="scrollToTop">{{ $t('app.cookiePolicy') }}</router-link>
        .
        <br/>
        <b-button size="sm" @click="this.acceptCookies">{{ $t('app.accept') }}</b-button>
      </b-alert>
    </div>

    <b-modal
        centered
        v-model="showComingSoon"
        size="lg"
    >
      <template #modal-header="{ close }">
        <div class="w-100 modal-header-top">{{ $t('app.weAreLaunchingSoon') }}</div>
        <b-button size="sm" variant="outline" @click="close()">X</b-button>
      </template>
      <div class="cs-main">
        <div class="cs-body">
          <div class="cs-logo"><img src="../src/assets/income.svg" alt="Income"></div>
          <h5>{{ $t('app.pleaseSignUp') }}</h5>
          <iframe src="//marketing.getincome.com/form/1" class="income-form"><p>{{ $t('app.yourBrowserDoes') }}</p></iframe>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100"></div>
      </template>
    </b-modal>

    <b-modal
        centered
        size="lg"
        v-model="showGetStarted"
        ref="modal"
    >
      <template #modal-header="{ close }">
        <div class="w-100 modal-header-top">{{ $t('app.weAreLaunchingSoon1') }}</div>
        <b-button size="sm" variant="outline" @click="close()">X</b-button>
      </template>
      <div class="cs-main">
        <div class="cs-body">
          <div class="cs-logo"><img src="../src/assets/income.svg" alt="Income"></div>
          <iframe src="//marketing.getincome.com/form/1" class="income-form"><p>{{ $t('app.yourBrowserDoes1') }}</p></iframe>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100"></div>
      </template>
    </b-modal>

    <b-modal
        centered
        size="lg"
        v-model="showUserAgreement"
        ref="modal"
    >
      <template #modal-header="{ close }">
        <div class="w-100 modal-header-top"></div>
        <b-button size="sm" variant="outline" @click="close()">X</b-button>
      </template>
      <div class="ua-main">
        <div class="ua-body">
          <user-agreement></user-agreement>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100"></div>
      </template>
    </b-modal>

    <b-modal
        centered
        size="lg"
        v-model="showUnavailable"
        ref="modal"
    >
      <template #modal-header>
        <div class="w-100 modal-header-top">{{ $t('app.yourAccountIs') }}</div>
      </template>
      <div class="cs-main">
        <div class="cs-body">
          <div>{{ $t('app.weAreSorry') }}</div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100  text-right"><b-button class="income-btn" onclick="location.reload()">{{ $t('app.refreshAgain') }}</b-button></div>
      </template>
    </b-modal>

    <b-modal
        centered
        size="lg"
        v-model="showClosedAccount"
        ref="modal"
    >
      <template #modal-header>
        <div class="w-100 modal-header-top">{{ $t('app.dearInvestorYour') }}</div>
      </template>
      <div class="cs-main">
        <div class="cs-body">
          <div>{{ $t('app.forFurtherInformation') }}<a href="mailto:hello@getincome.com">{{ $t('app.hellogetincomecom') }}</a>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 "> </div>
      </template>
    </b-modal>

    <b-modal
        centered
        size="lg"
        v-model="showError"
        ref="modal"
    >
      <template #modal-header="{ close }">
        <div class="w-100 modal-header-top">Something went wrong...</div>
        <b-button size="sm" variant="outline" @click="close()">X</b-button>
      </template>
      <div class="cs-main">
        <div class="cs-body">
          <div>{{ error.message }}</div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
<!--          <b-button size="sm" class="income-btn" @click="showError=false">Got it</b-button>-->
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import UserAgreement from '@/views/UserAgreement'
import localStorageHelper from '@/helpers/localStorageHelper'
import trackingHelper from '@/helpers/trackingHelper'

export default {
  components: {UserAgreement, Navbar, Footer},
  data()
  {
    return {
      showNav: true,
      showComingSoon: false,
      showGetStarted: false,
      showCookieAlert: true,
      showUserAgreement: false,
      showUnavailable: false,
      showClosedAccount: false,
      showError: false,
      error: {
        code: 0,
        message: '',
        redirect: ''
      },
      topMargin: '',
      authPages: false
    }
  },
  created()
  {
    this.setAuthPages()
    this.$store.dispatch('fetchInfoBanners')
    this.$root.$on('shownav', (show) =>
    {
      this.showNav = show
    })
    this.$root.$on('showcomingsoon', (show) =>
    {
      this.showComingSoon = show
    })
    this.$root.$on('showgetstarted', (show) =>
    {
      this.showGetStarted = show
    })
    this.$root.$on('showuseragreement', (show) =>
    {
      this.showUserAgreement = show
    })
    this.$root.$on('showunavailable', (show) =>
    {
      this.showUnavailable = show
    })
    this.$root.$on('showclosedaccount', (show) =>
    {
      this.showClosedAccount = show
    })
  },
  mounted()
  {
    this.showCookieAlert = !this.$cookie.get('Cookie20201019')
    this.trackTargetCircleClick()
    this.trackUtmTags()
    // TODO REMOVE. only for test unavailable message
    if (this.$route.hash && this.$route.hash === '#MariTestUnavailable')
    {
      this.showUnavailable = true
    }
    const error = localStorageHelper.getJson('error')
    if (error)
    {
      // console.log('Catch logout error:', error)
      if (localStorageHelper.get('accessToken'))
      {
        // Logout user
        this.$auth.logout({
          returnTo: window.location.origin + '/logout'
        })
      } else {
        if (error.message) {
          // Show error modal
          this.showError = true
          this.error = error
        } else {
          // Situation for errors without show any errors, just redirect
          if (error.redirect && window.location.pathname !== error.redirect) {
            this.$router.push(error.redirect)
          }
        }
        localStorageHelper.remove('error')
      }
    }
  },
  updated()
  {
    this.setAuthPages()
    this.trackReferrer()
    this.trackLoginSuccessStatus()
    this.$root.$on('topinfobar', (show) =>
    {
          this.topMargin = show ? 'top-alert-margin' : ''
    })
  },
  watch: {
    showError: function (show)
    {
      if (!show && this.error.redirect && window.location.pathname !== this.error.redirect) {
        this.$router.push(this.error.redirect)
      }
    }
  },
  methods: {
    acceptCookies()
    {
      this.$cookie.set('Cookie20201019', true, 365 * 10)
      this.showCookieAlert = false
    },
    scrollToTop()
    {
      window.scrollTo(0, 0)
    },
    trackTargetCircleClick()
    {
      try
      {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams)
        {
          const clickId = urlParams.get('click_id')
          if (clickId)
          {
            this.$cookie.set('targetCircleClickId', clickId, 30)
          }
        }
      } catch (e)
      {
        console.log('Error with detecting trackTargetCircleClick:', e)
      }
    },
    trackUtmTags()
    {
      try
      {
        const utmTags = {}
        const allowedUtmTags = [
          'utm_source',
          'utm_medium',
          'utm_campaign',
          'utm_content',
          'utm_term',
          'fbclid',
          'gclid',
          'click_id'
        ]
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams)
        {
          allowedUtmTags.forEach(function (utmTagName)
          {
            if (urlParams.get(utmTagName))
            {
              utmTags[utmTagName] = urlParams.get(utmTagName)
            }
          })
          if (Object.keys(utmTags).length > 0)
          {
            this.$cookie.set('utmTags', JSON.stringify(utmTags), 30)
          }
        }
      }
      catch (e)
      {
        console.log('Error with detecting trackUtmTags:', e)
      }
    },
    trackReferrer()
    {
      const referrerUrl = localStorageHelper.get('referrerUrl')
      const skipHostnames = [
          'myaccount.google.com',
          'account.google.com',
          'accounts.google.com',
          'com.google.android.gm',
          'income.eu.auth0.com',
          'appleid.apple.com'
      ]
      if (!referrerUrl && document.referrer)
      {
        const url = new URL(document.referrer)
        if (url.hostname !== location.hostname && !skipHostnames.includes(url.hostname))
        {
          localStorageHelper.set('referrerUrl', document.referrer)
        }
      }
    },
    setAuthPages()
    {
      this.authPages = this.$route.meta.type === 'auth' && this.$route.path !== '/'
    },
    trackLoginSuccessStatus()
    {
      const loginProvider = localStorageHelper.get('loginProvider')
      const loginSuccess = localStorageHelper.get('login_success')
      if (loginSuccess && loginSuccess === this.$route.path)
      {
        localStorageHelper.set('loggedIn', true)
        trackingHelper.pushLoginEvent('login_success', loginProvider)
      }
    },
    getMainCssClasses()
    {
      let classes = ''
      classes += (this.showNav ? 'content' : 'content-without-menu')
      if (this.$route.path === '/contest') {
        classes += ' blue-bg'
      }
      return [classes]
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');

.container {
  font-family: 'Open Sans', sans-serif;
}

.content {
  margin-top: 70px;
}

.blue-bg{
  background-color: #F5FBFF !important;
}

.content-without-menu {
  margin-top: 40px;
}

.container-fluid .row div {
  /* For slicing debug:
  border: 1px solid #6E777A;*/
}

hr {
  background: #EDEFF2;
}

.blue {
  color: #30A7FE;
}

/*** BUTTONS ***/
.white-hollow-btn {
  color: #000000 !important;
  border: 2px solid #9DA0A6 !important;
  box-sizing: border-box !important;
  border-radius: 16px !important;
  background-color: transparent !important;

}

.income-form {
  width: 100%;
  height: 435px;
  border: none;
}

.cs-logo {
  text-align: center;
  width: 100%;
  display: inline-block;
}

.cookie-accept {
  z-index: 2000;
  opacity: 0.94;
  text-align: center;
}

.modal-header-top {
  font-size: 1.25rem;
  font-weight: 500;
  text-align: center;
  margin-left: 20px;
}

.cs-main {
  width: 100%;
  text-align: center;

  .cs-body {
    max-width: 600px;
    display: inline-block;
  }
}

.ua-main {
  width: 100%;
  text-align: center;

  .ua-body {
    max-width: 650px;
    display: inline-block;
  }
}

.income-btn {
  background: #30A7FE !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
  border-color: #30A7FE !important;
}

.top-alert-margin {
  margin-top: 65px;
}

.before-footer{
  margin-top: 15px;
  /*box-shadow: 0 6px 13px var(--primary);
  border-bottom: 4px solid var(--primary);*/
}

.btn-primary, .btn-outline-primary {
  border-color: #30A7FE !important;
}

[lang="de"] {
  .de-break-word {
    overflow-wrap: break-word;
  }
}

@media (min-width: 320px) and (max-width: 1250px) {
  .top-alert-margin {
    margin-top: 95px;
  }
}
@media (min-width: 320px) and (max-width: 650px) {
  .top-alert-margin {
    margin-top: 145px;
  }
}
</style>
